// material-ui
import { Stack, Skeleton } from '@mui/material';

// ==============================|| SKELETON - NOTIFICATION LIST ||============================== //

const SkeletonNotificationList = () => (
    <Stack direction="column" spacing={2} sx={{ px: 3 }}>
        <Skeleton variant="rounded" sx={{ borderRadius: 3 }} animation="wave" height={100} />
        <Skeleton variant="rounded" sx={{ borderRadius: 3 }} animation="wave" height={100} />
        <Skeleton variant="rounded" sx={{ borderRadius: 3 }} animation="wave" height={100} />
        <Skeleton variant="rounded" sx={{ borderRadius: 3 }} animation="wave" height={100} />
    </Stack>
);

export default SkeletonNotificationList;
